import React, { Component } from 'react';
import AdminDiscountsTable from './AdminDiscountsTable';

export class AdminDiscountsContent extends Component {
  render() {

    return (
      <AdminDiscountsTable titleTableList={this.props.titleTableList} />
    )

  }
}

export default AdminDiscountsContent


// WEBPACK FOOTER //
// ./src/components/Administration/AdminDiscounts/AdminDiscountsContent.js